/**
 * 우측 하단 고정 floating action button (FAB).
 *
 * - 클릭 시 대화창 열림/닫힘 토글
 * - 영구 숨김 상태에서는 렌더링 안 함
 * - 미인증 상태에서도 렌더링 안 함
 */
import React from "react";
import { Box, Fab, Tooltip } from "@mui/material";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";
import { useChatbot } from "./ChatbotProvider";

export default function ChatbotFAB() {
    const { visible, open, toggleOpen } = useChatbot();
    if (!visible) return null;
    if (open) return null; // 대화창 열려있으면 FAB 숨김 (창이 위치 차지)

    return (
        <Box sx={{
            position: "fixed",
            right: 24, bottom: 24,
            zIndex: 1300,
        }}>
            <Tooltip title="AI 비서" placement="left">
                <Fab
                    color="primary"
                    onClick={toggleOpen}
                    aria-label="AI 비서 열기"
                    sx={{
                        width: 56, height: 56,
                        boxShadow: "0 6px 20px rgba(37,99,235,0.35)",
                        "&:hover": { transform: "scale(1.04)" },
                        transition: "transform 0.15s",
                    }}
                >
                    <SmartToyRoundedIcon sx={{ fontSize: 28 }} />
                </Fab>
            </Tooltip>
        </Box>
    );
}
